import type { FC, RefObject } from "react";
import type { EmailSearchInput } from "../../../../../hooks/useEmailsRestApi";
import type { EmailWithStatus } from "../..";
import { HREmailsCardsUI } from "../HREmailsCards";
import { MatterEmailsCardsUI } from "../MatterEmailsCards";

export type EmailsCardsUIProps = {
  isMatter: boolean;
  emails: EmailWithStatus[];
  onSelectEmail: (id: string) => void;
  currentSearchInput: EmailSearchInput;
  scrollCardRef: RefObject<HTMLDivElement>;
  scrollCardId: string | null;
};

export const EmailsCardsUI: FC<EmailsCardsUIProps> = ({
  isMatter,
  emails,
  onSelectEmail,
  currentSearchInput,
  scrollCardRef,
  scrollCardId,
}) => {
  return isMatter ? (
    <MatterEmailsCardsUI
      emails={emails}
      onSelectEmail={onSelectEmail}
      currentSearchInput={currentSearchInput}
      scrollCardRef={scrollCardRef}
      scrollCardId={scrollCardId}
    />
  ) : (
    <HREmailsCardsUI
      emails={emails}
      onSelectEmail={onSelectEmail}
      currentSearchInput={currentSearchInput}
      scrollCardRef={scrollCardRef}
      scrollCardId={scrollCardId}
    />
  );
};
